import MasterService from '@/services/imports/manifest/master.service';
import HouseService from '@/services/house.service';
import IpiLoadService from '@/services/ipi/ipi.load.service';
import IpiLoadGuideService from '@/services/ipi/ipi.load.guide.service';
import OnHandService from '@/services/export/on-hand/on-hand.service';
import ExportLoadPlanService from '@/services/export/loads/export-load-plan.service';
import ExportLoadGuideService from '@/services/export/loads/export-load-guide.service';
import { FilterOptionServices } from '@/types/filter/filter-options';
import { FilterOptionsParams } from '@/types/service/filters.service';
import IpiReceiveService from '@/services/imports/receive/ipi.receive.service';
import { AxiosResponse } from 'axios';
import ImportReportsService from '@/services/reports/reports.service';
import ChargeService from '@/services/charges/charge.service';

export const FILTER_SERVICE_OPTIONS: Record<
  FilterOptionServices,
  <T>(params: Omit<FilterOptionsParams, 'limit'>) => Promise<AxiosResponse<T, any>>
> = {
  mbl: MasterService.getFilterOptions,
  hbl: HouseService.getFilterOptions,
  loadplan: IpiLoadService.getFilterOptions,
  loadguide: IpiLoadGuideService.getFilterOptions,
  onhand: OnHandService.getFilterOptions,
  export_loadplan: ExportLoadPlanService.getFilterOptions,
  export_loadguide: ExportLoadGuideService.getFilterOptions,
  ipi_tracking: IpiLoadGuideService.getTrackingFilterOptions,
  ipi_receiving: IpiReceiveService.getFilterOptions,
  invoice: ImportReportsService.getInvoiceFilterOptions,
  charge: ChargeService.getManifestChargesFilterOptions,
  mocked: async (_params) => {
    return <AxiosResponse>{};
  },
};
